@if (isCircleMode()) {
    <div
        class="container circle-mode"
        appTooltip
        trigger="hover"
        [componentData]="'listing.contentScoring.header' | translate"
        position="top"
        [showDelay]="200"
        [hideDelay]="200"
    >
        <svg class="circle-progress" viewBox="0 0 80 80" [ngClass]="progressClass()">
            <defs>
                <linearGradient [attr.id]="'gaugeGradient-' + progressClass()" x1="0%" y1="0%" x2="100%" y2="0%">
                    <stop offset="0%" [attr.stop-color]="gradientStartColor()" />
                    <stop offset="100%" [attr.stop-color]="gradientEndColor()" />
                </linearGradient>
            </defs>
            <circle class="circle-track" cx="40" cy="40" [attr.r]="circleRadius" />
            <circle
                class="circle-fill"
                cx="40"
                cy="40"
                [attr.r]="circleRadius"
                [attr.stroke]="'url(#gaugeGradient-' + progressClass() + ')'"
                [ngStyle]="circleStrokeStyle()"
            />
        </svg>
        <div class="gauge-text">{{ animatedPercentage() }}%</div>
    </div>
} @else {
    <div
        class="container"
        appTooltip
        trigger="hover"
        [componentData]="'listing.contentScoring.header' | translate"
        position="top"
        [showDelay]="200"
        [hideDelay]="200"
    >
        <nav class="progress" [ngClass]="progressClass()" [ngStyle]="gaugeStyle()"></nav>
        <div class="gauge-text">{{ animatedPercentage() }}%</div>
    </div>
}
